module.exports = __webpack_public_path__ + "img/1.72483d19.png";